function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M101.351 0.430298L108.053 21.0562L129.74 21.0562L112.195 33.8037L118.896 54.4297L101.351 41.6821L83.8054 54.4297L90.5072 33.8037L72.9617 21.0562L94.6491 21.0562L101.351 0.430298Z",
  fill: "#FCC957"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.0838 0.430298L36.7855 21.0562L58.4729 21.0562L40.9275 33.8037L47.6292 54.4297L30.0838 41.6821L12.5383 54.4297L19.2401 33.8037L1.69461 21.0562L23.382 21.0562L30.0838 0.430298Z",
  fill: "#FCC957"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M172.617 0.430298L179.318 21.0562L201.006 21.0562L183.46 33.8037L190.162 54.4297L172.617 41.6821L155.071 54.4297L161.773 33.8037L144.228 21.0562L165.915 21.0562L172.617 0.430298Z",
  fill: "#FCC957"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M243.884 0.430298L250.586 21.0562L272.273 21.0562L254.728 33.8037L261.429 54.4297L243.884 41.6821L226.338 54.4297L233.04 33.8037L215.495 21.0562L237.182 21.0562L243.884 0.430298Z",
  fill: "#FCC957"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M315.15 0.430298L321.852 21.0562L343.539 21.0562L325.994 33.8037L332.695 54.4297L315.15 41.6821L297.604 54.4297L304.306 33.8037L286.761 21.0562L308.448 21.0562L315.15 0.430298Z",
  fill: "#FCC957"
});

var SvgStars = function SvgStars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 61,
    viewBox: "0 0 345 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stars.8e8d2499.svg";
export { ForwardRef as ReactComponent };